import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		activeModel: "1",
		// 开具端跳转利用端查看
		uploadSourceFromIssue: false,
		uploadFromIssue: {},
		announcementList: [
			{ title: '数科OFD文档处理软件V3.0漏洞修复公告', time: '2022/10/14', id:"2022101401" },
			{ title: '官网数科OFD版式软件V5.0漏洞修复公告', time: '2023/09/14', id:"2023091401" },
		]
	},
	getters: {
		activeModel: state => state.activeModel,
		uploadSourceFromIssue: state => state.uploadSourceFromIssue
	},
	mutations: {
		SET_ACTIVEMODEL: (state, data) => {
			state.activeModel = data;
		},
		SET_UPLOADSOURCE: (state, data) => {
			state.uploadSourceFromIssue = data;
		},
		SET_UPLOADISSUEDATA: (state, data) => {
			state.uploadFromIssue = data;
		}
	},
	actions: {},
	modules: {}
});



// WEBPACK FOOTER //
// ./src/supubwps-document-conversion/store/index.js